<template>
  <div class="d-flex justify-content-between align-items-center">
    <div class="w-38">
      <div class="input-group w-100 position-relative">
        <input
          v-model="productCode"
          type="search"
          class="form-control input"
          autocomplete="off"
          :disabled="selectedStructure"
          @focus="focusSet('productCode')"
          @blur="blurSet('productCode')"
          :placeholder="$t('品番')"
        />
        <div class="input-group-append">
          <button @click="disabledRelease()" class="btn btn-light h-100" type="button"
          >選択解除</button>
        </div>
        <div v-if="searchCode" class="list-group searchList">
          <a
            v-for="(item) in filterCode"
            :key="item.id"
            @click="onClickProduct(item)"
            class="list-group-item list-group-item-action"
          >{{ item.productCode }}/{{ item.productName }}/{{ item.productVersion }}</a>
        </div>
      </div>
    </div>
    <div class="w-38">
      <div class="input-group w-100 position-relative">
        <input
          v-model="productName"
          type="search"
          class="form-control input"
          autocomplete="off"
          :disabled="selectedStructure"
          @focus="focusSet('name')"
          @blur="blurSet('name')"
          :placeholder="$t('品名')"
        />
        <div class="input-group-append">
          <button @click="disabledRelease()" class="btn btn-light h-100" type="button"
          >選択解除</button>
        </div>
        <div v-if="searchName" class="list-group searchList">
          <a
            v-for="(item) in filterName"
            :key="item.id"
            @click="onClickProduct(item)"
            class="list-group-item list-group-item-action"
          >{{ item.productCode }}/{{ item.productName }}/{{ item.productVersion }}</a>
        </div>
      </div>
    </div>
    <div class="w-17">
      <input
        :value="quantity"
        class="form-control input"
        type="number"
        min="0"
        :placeholder="$t('数量')"
      >
    </div>
    <button
      type="button"
      class="btn btn-danger wf-50 h-auto"
      @click="removeStructure()"
    >{{ $t('削除') }}</button>
  </div>
</template>

<script>

export default {
  props: {
    structure: {
      type: Object,
      default: () => {},
    },
    structures: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  async mounted() {
    if (!this.structure.id) return
    this.selectedStructure = this.structure
    this.productCode = this.structure.productCode
    this.productName = this.structure.productName
    this.quantity = this.structure.quantity
  },
  data() {
    return {
      productName: '',
      productCode: '',
      selectedStructure: null,
      quantity: null,
      // disabled: false,
      searchCode: false,
      searchName: false,
    }
  },
  methods: {
    // 検索が可能なところのフォーカスされた時の処理
    focusSet(key) {
      if (key === 'productName') {
        this.searchName = true
      } else if (key === 'productCode') {
        this.searchCode = true
      }
    },
    // 検索が可能なところのフォーカスが外れた時の処理
    blurSet(key) {
      if (key === 'productName') {
        setTimeout(() => {
          this.searchName = false
        }, 200)
      } else if (key === 'productCode') {
        setTimeout(() => {
          this.searchCode = false
        }, 200)
      }
    },
    // 既存の構成図のクリックされた時の処理
    onClickProduct(item) {
      this.selectedStructure = item
    },
    disabledRelease() {
      this.selectedStructure = null
    },
    addStructure() {
      this.$emit('addStructure')
    },
    removeStructure() {
      this.$emit('removeStructure')
    },
  },
  computed: {
    shapingOneArray() {
      if (this.structures.length === 0) return []
      let oneArray = []
      const arrayMap = (item) => {
        item.structures.map(structure => {
          oneArray.push(structure)
          if (structure.structures.length !== 0) arrayMap(structure)
        })
      }
      arrayMap(this.mixin_deepcopy(this.structures))
      return oneArray
    },
    filterCode() {
      if (this.structures.length === 0 || this.isEmpty(this.productCode)) return []
      const regexp = new RegExp(`^${this.productCode}`,)
      return this.shapingOneArray.filter(item => {
        return (
          item.productCode &&
          item.productCode.search(regexp) != -1 &&
          (!item.productProcessId || item.productProcessId === this.structure.productProcessId)
        )
      })
    },
    filterName() {
      if (this.structures.length === 0 || this.isEmpty(this.productName)) return []
      const regexp = new RegExp(`^${this.productName}`)
      return this.shapingOneArray.filter(item => {
        return (
          item.productName &&
          item.productName.search(regexp) != -1 &&
          (!item.productProcessId || item.productProcessId === this.structure.productProcessId)
        )
      })
    },
  },
  watch: {
    selectedStructure: function(newVal) {
      if (newVal) {
        this.productCode = newVal.productCode
        this.productName = newVal.productName
      }
      this.$emit('changeStructure', {value: newVal, key: 'quantity'})
    },
  },
}
</script>

<style lang="scss">
</style>
